import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { SvbrgLanguage } from '@/generated/gql/graphql';
import { i18n } from '~/common/i18n';

export const intakeGenerateStatementOfWorkStepFormDataSchema = z.object({
  statementOfWork: z.string().min(1),
  language: z.enum(SvbrgLanguage),
});

export type IntakeGenerateStatementOfWorkStepFormData = z.infer<typeof intakeGenerateStatementOfWorkStepFormDataSchema>;

export const intakeGenerateStatementOfWorkStepFormDataDefault: DefaultValues<IntakeGenerateStatementOfWorkStepFormData> =
  {
    statementOfWork: '',
    language:
      !i18n.language || i18n.language === 'dx' ? SvbrgLanguage.DE : (i18n.language.toUpperCase() as SvbrgLanguage),
  };
